import React from 'react';
import { useSelector } from 'react-redux';
import { dataForLicenseDisplay } from 'software_renewal/redux/selectors';

const ViewMateProffesionalPromoSection = () => {
  const licenseInfo = useSelector(dataForLicenseDisplay);
  const { products } = licenseInfo;

  if (!licenseInfo?.products?.length) {
    return null;
  }

  if (!products.some(({ product }) => product.name === 'ViewMate Pro')) {
    return null;
  }

  return (
    <div className="viewmate-professional-promo-section container-fluid px-0">
      <div className="container-fluid container-xl">
        <div className="row">
          <div className="col-12">
            <div className="announcement-banner">
              <h1 className="announcement-title font-heavy d-flex align-items-center justify-content-center">
                <img src={Spree.image_assets.announcement_icon} alt="Announcement Icon" className="mr-2" />
                Important Announcement
              </h1>
              <h2 className="announcement-subtitle font-heavy">
                ViewMate Pro has been retired but as a valued ViewMate Pro <br className="d-none d-md-block" />
                customer, you are eligible for a complimentary upgrade!
              </h2>
            </div>
            <p className="announcement-description text-center font-heavy">
              Your perpetual ViewMate Pro license will remain fully functional without
              interruption; however, no further versions will be released. We
              will continue to provide support by phone or email until your
              maintenance contract expires.
            </p>
          </div>

          <div className="col-12">
            <div className="upgrade-section">
              <h3 className="upgrade-title font-heavy mb-4">
                Upgrade Now to ViewMate Professional
              </h3>
              <p className="upgrade-description mb-4">
                CAMMaster, our premier CAM software, once available only to PCB fabricators and EMS providers, is now accessible to all designers through an affordable annual subscription. ViewMate Professional combines all the capabilities of CAMMaster including scripting for automation with PCB Navigator, the latest innovation from ViewMate Essentials, to deliver truly comprehensive CAM solution.
              </p>
              <p className="upgrade-description mb-4">
                Below are some of the new features included in ViewMate Professional that were not available in ViewMate Pro.
              </p>
            </div>
          </div>
          <div className="col-12 col-lg-6 upgrade-section">
            <ul className="mb-0">
              <li className="mb-1">CAM Automation with Macros and .NET Scripting</li>
              <li className="mb-1">PCB Navigator with Views and Reports</li>
              <li className="mb-1">ODB++ Export</li>
              <li className="mb-1">Routing Tools</li>
              <li className="mb-1">Merge Polygons</li>
              <li className="mb-1">Advanced DFM Checks</li>
              <li className="mb-1">AOI Tools</li>
              <li className="mb-1">Export GDS-TXT</li>
              <li className="mb-1">Automated Draw To Flash</li>
              <li className="mb-1">Select By Intersection</li>
              <li className="mb-1">SolderMask Generation</li>
              <li className="mb-1">Venting and Thieving</li>
              <li className="mb-1">Netlist Extraction (Contour and Raster)</li>
              <li className="mb-1">Netlist Compare</li>
              <li className="mb-1">COM (Active X) Accessible</li>
            </ul>
            <div className="mt-5">
              <a href="/products/viewmate-professional" className="learn-more-btn px-4 py-3">
                Learn More
              </a>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="image-wrapper position-relative">
              <img
                src={Spree.image_assets.scripting_image}
                loading="lazy"
                className="foreground-image img-fluid position-relative"
                alt="Using Scripting to Automate PCB Panelization"
              />
            </div>
          </div>
        </div>

        <div className="row pcb-navigator-section mt-5">
          <div className="col-12 col-lg-5">
            <div className="image-wrapper position-relative">
              <img
                src={Spree.image_assets.pcb_navigator_image}
                loading="lazy"
                className="foreground-image img-fluid position-relative"
                alt="PCB Navigator"
              />
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <h3 className="title font-heavy mb-0">
              PCB Navigator
            </h3>
            <p className="subtitle font-heavy">
              ViewMate Professional includes our PCB Navigator, a software tool used to visually search and inspect components using only fabrication files.
            </p>
            <p className="lead font-medium">
              Essentially, it &quot;adds intelligence&quot; to static Gerber files by integrating  them with Bill of Materials and XY Data, turning them into an interactive, searchable environment for inspection, troubleshooting, and documentation. This integration allows users designers, manufacturers, assemblers, or brokers to:
            </p>
            <ul className="mb-0">
              <li className="mb-1 font-medium">Identify and locate specific components directly on the PCB layout.</li>
              <li className="mb-1 font-medium">Cross-reference part numbers, footprints, and placement coordinates.</li>
              <li className="mb-1 font-medium">Verify design details before manufacturing and assembly.</li>
              <li className="mb-1 font-medium">Navigate between schematic data and physical PCB locations.</li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="subscription-section">
              <div className="row align-items-center">
                <div className="software-box-image">
                  <img
                    src={Spree.image_assets.viewmate_professional}
                    alt="ViewMate Professional Software Box"
                  />
                </div>
                <div className="col-12">
                  <div className="subscription-content">
                    <p className="subscription-title font-heavy">
                      ViewMate Professional is subscription-only, a 50% renewal discount will be offered for the next three years.
                    </p>
                    <p className="subscription-text">
                      As a valued ViewMate Pro customer, you are eligible for
                      a complimentary upgrade that will remain active throughout the remainder of your maintenance period. If your
                      maintenance has lapsed, we&apos;ll extend a <span className="font-heavy">50% discount</span>.
                    </p>
                    <p className="subscription-text">
                      You will receive an email with instructions on how to download your complimentary ViewMate Professional annual subscription license.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMateProffesionalPromoSection;
